/**
 * AJAX-поиск товаров.
 */
(function () {
	'use strict';

	// Верстка в инспекторе: true = не прячем дропдаун и не снимаем is-active. Потом поставь false.
	const WPS_SEARCH_DEBUG_PREVIEW = false;

	const DEBOUNCE_DELAY = 300;

	const DEBUG_PREVIEW_HTML =
		'<div class="wp-block-wps-blocks-search__results">' +
		'<a class="wp-block-wps-blocks-search__card" href="#">' +
		'<div class="wp-block-wps-blocks-search__card-image"></div>' +
		'<div class="wp-block-wps-blocks-search__card-content">' +
		'<div class="wp-block-wps-blocks-search__card-meta">' +
		'<span class="wp-block-wps-blocks-search__card-sku">АРТ: DEMO-1</span>' +
		'<button type="button" class="wp-block-wps-blocks-search__card-copy" data-copy-sku="DEMO-1" title="Копировать">×</button>' +
		'</div>' +
		'<h4 class="wp-block-wps-blocks-search__card-title">Пример названия товара для вёрстки</h4>' +
		'<span class="wp-block-wps-blocks-search__card-attr">450 мл</span>' +
		'</div></a>' +
		'</div>' +
		'<div class="wp-block-wps-blocks-search__footer">' +
		'<span class="wp-block-wps-blocks-search__count">Найдено: 99</span>' +
		'<a class="wp-block-wps-blocks-search__all" href="#"><span class="wp-block-wps-blocks-search__all-label">Показать все результаты</span></a>' +
		'</div>';

	function debounce(fn, delay) {
		let timer = null;
		return function (...args) {
			clearTimeout(timer);
			timer = setTimeout(() => fn.apply(this, args), delay);
		};
	}

	function initSearchBlock(container) {
		const form = container.querySelector('[data-search-form]');
		const field = container.querySelector('[data-search-field]');
		const input = container.querySelector('[data-search-input]');
		const clearBtn = container.querySelector('[data-search-clear]');
		const dropdown = container.querySelector('[data-search-dropdown]');

		if (!input || !dropdown) {
			return;
		}

		const minChars = parseInt(input.dataset.minChars, 10) || 3;
		const resultsPerPage = Math.min(
			50,
			Math.max(1, parseInt(container.dataset.resultsPerPage, 10) || 12)
		);
		let xhr = null;

		function updateClearButton() {
			if (!clearBtn) {
				return;
			}
			const isOpen =
				container.classList.contains('is-active') ||
				container.classList.contains('has-dropdown');
			clearBtn.hidden = !isOpen;
		}

		function activate() {
			container.classList.add('is-active');
			updateClearButton();
		}

		function deactivate() {
			if (WPS_SEARCH_DEBUG_PREVIEW) {
				return;
			}
			container.classList.remove('is-active');
			updateClearButton();
		}

		function isDropdownVisible() {
			return !dropdown.hidden && dropdown.innerHTML.trim() !== '';
		}

		function showDropdown(html) {
			dropdown.innerHTML = html;
			dropdown.hidden = false;
			container.classList.add('has-dropdown');
			updateClearButton();
		}

		function hideDropdown() {
			if (WPS_SEARCH_DEBUG_PREVIEW) {
				return;
			}
			dropdown.hidden = true;
			dropdown.innerHTML = '';
			container.classList.remove('has-dropdown');
			updateClearButton();
		}

		function resetSearch() {
			if (xhr) {
				xhr.abort();
				xhr = null;
			}
			input.value = '';
			deactivate();
			hideDropdown();
			input.blur();
		}

		function doSearch(query) {
			if (xhr) {
				xhr.abort();
			}

			if (query.length < minChars) {
				hideDropdown();
				return;
			}

			xhr = new XMLHttpRequest();
			xhr.open('POST', wpsBlocksSearch.ajaxUrl, true);
			xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

			xhr.onreadystatechange = function () {
				if (xhr.readyState === 4) {
					if (xhr.status === 200) {
						try {
							const response = JSON.parse(xhr.responseText);
							if (response.success && response.data.html) {
								showDropdown(response.data.html);
							} else {
								hideDropdown();
							}
						} catch (e) {
							hideDropdown();
						}
					}
				}
			};

			const params =
				'action=wps_blocks_search&nonce=' +
				encodeURIComponent(wpsBlocksSearch.nonce) +
				'&s=' +
				encodeURIComponent(query) +
				'&per_page=' +
				encodeURIComponent(String(resultsPerPage));

			xhr.send(params);
		}

		const debouncedSearch = debounce(doSearch, DEBOUNCE_DELAY);

		input.addEventListener('input', function (e) {
			const query = e.target.value.trim();
			debouncedSearch(query);
		});

		input.addEventListener('focus', function () {
			activate();
			const query = input.value.trim();
			if (query.length >= minChars) {
				debouncedSearch(query);
			}
		});

		if (field) {
			field.addEventListener('click', function (e) {
				if (e.target.closest('[data-search-clear]')) {
					return;
				}
				input.focus();
			});
		}

		if (clearBtn) {
			clearBtn.addEventListener('mousedown', function (e) {
				e.preventDefault();
			});

			clearBtn.addEventListener('click', function (e) {
				e.preventDefault();
				e.stopPropagation();
				resetSearch();
			});
		}

		input.addEventListener('blur', function () {
			setTimeout(function () {
				if (!isDropdownVisible()) {
					deactivate();
				}
			}, 150);
		});

		form.addEventListener('submit', function (e) {
			if (input.value.trim().length < minChars) {
				e.preventDefault();
			}
		});

		document.addEventListener('click', function (e) {
			if (container.contains(e.target)) {
				return;
			}
			deactivate();
			if (isDropdownVisible()) {
				hideDropdown();
			}
		});

		document.addEventListener('keydown', function (e) {
			if (e.key === 'Escape') {
				deactivate();
				hideDropdown();
				input.blur();
			}
		});

		dropdown.addEventListener('click', function (e) {
			const copyBtn = e.target.closest('[data-copy-sku]');
			if (copyBtn) {
				e.preventDefault();
				e.stopPropagation();
				const sku = copyBtn.dataset.copySku;
				if (sku && navigator.clipboard) {
					navigator.clipboard.writeText(sku);
				}
			}
		});

		if (WPS_SEARCH_DEBUG_PREVIEW) {
			activate();
			showDropdown(DEBUG_PREVIEW_HTML);
			input.value = 'demo';
		}
	}

	function init() {
		const blocks = document.querySelectorAll('.wp-block-wps-blocks-search');
		blocks.forEach(initSearchBlock);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
